import { toggleToast } from '@bilibili-maoer/prelude'

import { useState } from 'react'

import { match } from 'ts-pattern'

import { InviteDialog } from './invite'

import { AppError } from '~/app/error'
import { Title } from '~/core/components/title'
import { safeParseInt } from '~/core/utils/safe-parse-int'
import { ContractDetails } from '~/features/guild/contract/components/contract-form'
import { EDurationID } from '~/features/guild/contract/enums'
import { GuildApi } from '~/services/fm/guild'
import CenterCircularProgress from '~/shared/components/center-circular-progress'
import AppNavigate from '~/shared/navigation/app-navigate'
import useAppNavigate from '~/shared/navigation/use-app-navigate'
import useAppSearchParam from '~/shared/navigation/use-app-search-params'

export const GuildJoin = () => {
  const [searchParams] = useAppSearchParam()
  const ownerId = safeParseInt(searchParams.get('owner_id'))
  return (
    <>
      <Title>公会签约申请</Title>
      {ownerId === undefined ? <AppNavigate to=".." replace /> : <GuildJoinInner ownerId={ownerId} />}
    </>
  )
}

const GuildJoinInner = (props: { ownerId: number }) => {
  const navigate = useAppNavigate()
  const [inviteDialogContent, setInviteDialogContent] = useState<string>()
  const { data: [info] = [], isLoading } = GuildApi.searchGuild.useQuery({ ownerId: props.ownerId })
  const [triggerJoin, joinResult] = GuildApi.joinGuild.useMutation()

  if (isLoading) {
    return <CenterCircularProgress />
  }

  if (!info) {
    return AppError.throw({ type: 'NOT_FOUND' })
  }

  return (
    <>
      <ContractDetails
        data={{
          guildId: info.id,
          guildName: info.guild_name,
          masterId: info.user_id,
          rateString: info.rate_string,
          settlement: info.settlement,
        }}
        source="apply"
        operator="join"
        isLoading={joinResult.isLoading}
        onSubmit={async (input, data) => {
          match(
            await triggerJoin({
              guild_id: data.guildId,
              duration: input.duration ?? EDurationID.FiveYears,
            }).unwrap()
          )
            .with({ state: 'applied' }, ({ message }) => {
              toggleToast(message)
              navigate('..', { replace: true })
            })
            .with({ state: 'invited' }, ({ message }) => {
              setInviteDialogContent(message)
            })
        }}
      />

      <InviteDialog
        content={inviteDialogContent}
        ownerId={info.user_id}
        onClose={() => setInviteDialogContent(undefined)}
      />
    </>
  )
}
